<!--*****************************************************************
  * Copyright (c) Certus Software, 2021.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<div [@fadeInOutAnimation]="true" class="page-wrapper">
  <section class="{{translate.currentLang}}">
    <div class="inner">
      <div class="inner-grid">
        <h1 class="extra-large">
          404
        </h1>
        <h2>
          {{'httpErrors.notAvailable' | translate}}
        </h2>
      </div>
    </div>
  </section>
</div>
